/**
 * @file Named elevation shadow ladder for consistent depth hierarchy.
 *
 * `shadowValues` holds the literal per-scheme values; `shadows` keeps the
 * original key paths as `var(--dt-shadow-…)` references so Mantine and all
 * existing consumers resolve them per color scheme.
 *
 * Dark shadows pair a warm 1px inner ring with a true-black ambient shadow —
 * charcoal-tinted shadows are invisible on dark surfaces. Floating layers
 * (popover/modal) should also sit on surface.overlayRaised: elevation in dark
 * is communicated by lightness first, shadow second.
 */

export const shadowValues = {
  light: {
    flat: 'none',
    card: '0 1px 2px rgba(30,41,59,.04), 0 4px 12px rgba(30,41,59,.06)',
    cardHover: '0 8px 24px rgba(30,41,59,.10)',
    popover: '0 12px 32px rgba(30,41,59,.14)',
    modal: '0 24px 64px rgba(30,41,59,.20)',
    sticky: '0 2px 16px rgba(30,41,59,.08)'
  },
  dark: {
    flat: '0 1px 2px rgba(0,0,0,0.45)',
    card: '0 0 0 1px rgba(250,245,235,0.05), 0 2px 8px rgba(0,0,0,0.50)',
    cardHover: '0 0 0 1px rgba(250,245,235,0.08), 0 6px 16px rgba(0,0,0,0.55)',
    popover: '0 0 0 1px rgba(250,245,235,0.08), 0 8px 24px rgba(0,0,0,0.60)',
    modal: '0 0 0 1px rgba(250,245,235,0.08), 0 16px 48px rgba(0,0,0,0.65)',
    sticky: '0 4px 12px rgba(0,0,0,0.50)'
  }
};

export const shadows = Object.fromEntries(Object.keys(shadowValues.light).map((key) => [key, `var(--dt-shadow-${key})`]));
